import { apiClient } from './api/client';
import { Category, SubCategory, CategoryWithSubCategories, CreateCategoryDto, UpdateCategoryDto, CreateSubCategoryDto, UpdateSubCategoryDto } from '@/types/category.types';

export const categoryService = {
  async getAll(): Promise<CategoryWithSubCategories[]> {
    return await apiClient.get<CategoryWithSubCategories[]>('/categories');
  },

  async getById(id: number): Promise<CategoryWithSubCategories> {
    return await apiClient.get<CategoryWithSubCategories>(`/categories/${id}`);
  },

  async create(data: CreateCategoryDto): Promise<Category> {
    return await apiClient.post<Category>('/categories', data);
  },

  async update(id: number, data: UpdateCategoryDto): Promise<Category> {
    return await apiClient.put<Category>(`/categories/${id}`, data);
  },

  async delete(id: number): Promise<void> {
    return await apiClient.delete(`/categories/${id}`);
  },

  async getSubCategoriesByCategoryId(categoryId: number): Promise<SubCategory[]> {
    return await apiClient.get<SubCategory[]>(`/categories/${categoryId}/subcategories`);
  },

  async getSubCategoryById(id: number): Promise<SubCategory> {
    return await apiClient.get<SubCategory>(`/categories/subcategories/${id}`);
  },

  async createSubCategory(data: CreateSubCategoryDto): Promise<SubCategory> {
    return await apiClient.post<SubCategory>('/categories/subcategories', data);
  },

  async updateSubCategory(id: number, data: UpdateSubCategoryDto): Promise<SubCategory> {
    return await apiClient.put<SubCategory>(`/categories/subcategories/${id}`, data);
  },

  async deleteSubCategory(id: number): Promise<void> {
    return await apiClient.delete(`/categories/subcategories/${id}`);
  },
};

